module.exports = __webpack_public_path__ + "img/ajax.a73be93e.jpeg";